<template>
  <!-- 教师统计 -->
  <Echart :options="options" height="440px" width="100%"></Echart>
</template>

<script>
import Echart from '@/common/echart';
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    LBdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    LBdata: {
      handler(newData) {
        let colorList = [
          '#d16713',
          '#0285df',
          '#d169b5',
          '#3cb162',
          '#e8307a',
          '#f3c824',
          '#e7421b',
          '#afa3f5',
          '#00d488',
          '#3feed4',
          '#3bafff',
          '#f1bb4c'
        ];
        this.options = {
          grid: {
            top: '35%',
            left: '10%',
            right: '10%',
            bottom: '10%',
            containLabel: true
          },
          legend: {
            show: false
          },
          // graphic: {
          //   // 中间文字
          //   type: 'text',
          //   left: 'center',
          //   top: '42%',
          //   style: {
          //     text: '10人',
          //     textAlign: 'center',
          //     fill: '#fff',
          //     fontSize: 40
          //   }
          // },
          title: {
            text: newData.total + '人', //主标题文本
            subtext: '', //副标题文本
            left: 'center',
            top: '40%',
            textStyle: {
              fontSize: 38,
              color: '#fff',
              align: 'center'
            },
            subtextStyle: {
              fontSize: 16,
              color: '#6c7a89'
            }
          },
          series: [
            {
              radius: ['36%', '50%'],
              center: ['50%', '45%'],
              // avoidLabelOverlap: false,
              itemStyle: {
                normal: {
                  color: function (params) {
                    return colorList[params.dataIndex];
                  }
                }
              },
              hoverAnimation: false, // 鼠标经过不放大
              labelLine: {
                normal: {
                  length: 20, // 指示线长度
                  length2: 30,
                  lineStyle: {
                    color: '#ffe92c', // 指示线颜色
                    width: 2
                  }
                }
              },
              label: {
                position: 'outside',
                normal: {
                  formatter: '{b|{b}}\n\n{c}人',
                  textStyle: {
                    fontSize: 19,
                    color: '#ffe92c' // 改变标示文字的颜色
                  },
                  rich: {
                    b: {
                      fontSize: 19,
                      color: '#ffffff'
                    }
                  }
                }

                // padding: [0, -40, 0, -30],
              },
              type: 'pie',
              data: newData.data
            }
          ]
        };
      },
      // immediate: true,
      deep: true
    }
  }
};
</script>
